import React, { createContext, useState, useMemo } from "react";
import { api } from "../middlewares";

const ContextPagamentoCartao = createContext();

function PagamentoCartao({ children }) {
  const [openModalCardPayment, setOpenModalCardPayment] = useState(false);
  const [parcelasCardPayment, setParcelasCardPayment] = useState([]);

  const handleOpenModalCardPayment = () => {
    setOpenModalCardPayment(!openModalCardPayment);
  };

  const postPagarCartao = async (payload) => {
    const response = await api.post("/Cartao/RecebimentoCartao", payload);
    return response.data;
  };

  const value = useMemo(
    () => ({
      handleOpenModalCardPayment,
      postPagarCartao,
      parcelasCardPayment,
      setParcelasCardPayment,
      openModalCardPayment,
    }),
    [openModalCardPayment, parcelasCardPayment]
  );

  return (
    <ContextPagamentoCartao.Provider value={value}>
      {children}
    </ContextPagamentoCartao.Provider>
  );
}

export { ContextPagamentoCartao, PagamentoCartao };
